module.exports = __webpack_public_path__ + "img/34ne.cf10eb4a.svg";